<template lang="pug">
  div.tel-dropdown(:class="{'is-open': isOpen}" @click="toggleState")
    div.tel-dropdown__display
      div.tel-dropdown__display-state
      span.tel-dropdown__display-data(v-if="selected") {{selected.code}}
    div.tel-dropdown__dropdown
      ul.tel-dropdown__list(v-if="selected" ref="telPrefixList")
        template(v-for="item in codes")
          li.tel-dropdown__list-item(:class="{'is-selected': item.code === selected.code}" @click="setSelected(item)")
            span.tel-dropdown__list-name {{item.nameEN + ' '}}
            span.tel-dropdown__list-code {{item.code}}
</template>

<script>
  export default {
    name: 'TelDropdown',
    props: {
      cb: {
        type: Function,
        default: () => {}
      }
    },
    mounted () {
      this.$nextTick(() => {
        const selected = this.$store.state.answers.phonePrefix;
        if (selected) {
          this.selected = selected;
        } else {
          this.setSelected(this.codes.filter((item) => {
            return item.code === '+7';
          })[0])
        }
      })
    },
    data () {
      return {
        codes: [
            {
                'nameRU': '\u0410\u0444\u0433\u0430\u043d\u0438\u0441\u0442\u0430\u043d',
                'nameEN': 'Afghanistan',
                'code': '+93'
            },
            {
                'nameRU': '\u0410\u043b\u0431\u0430\u043d\u0438\u044f',
                'nameEN': 'Albania',
                'code': '+355'
            },
            {
                'nameRU': '\u0410\u043b\u0436\u0438\u0440',
                'nameEN': 'Algeria',
                'code': '+21'
            },
            {
                'nameRU': '\u0410\u043c\u0435\u0440\u0438\u043a\u0430\u043d\u0441\u043a\u043e\u0435 \u0421\u0430\u043c\u043e\u0430',
                'nameEN': 'American Samoa',
                'code': '+684'
            },
            {
                'nameRU': '\u0410\u043d\u0434\u043e\u0440\u0440\u0430',
                'nameEN': 'Andorra',
                'code': '+376'
            },
            {
                'nameRU': '\u0410\u043d\u0433\u043e\u043b\u0430',
                'nameEN': 'Angola',
                'code': '+244'
            },
            {
                'nameRU': '\u0410\u043d\u0433\u0443\u0438\u043b\u043b\u0430',
                'nameEN': 'Anguilla',
                'code': '+1-264'
            },
            {
                'nameRU': '\u0410\u043d\u0442\u0438\u0433\u0443\u0430 \u0438 \u0411\u0430\u0440\u0431\u0443\u0434\u0430',
                'nameEN': 'Antigua and Barbuda',
                'code': '+1-268'
            },
            {
                'nameRU': '\u0410\u0440\u0433\u0435\u043d\u0442\u0438\u043d\u0430',
                'nameEN': 'Argentina',
                'code': '+54'
            },
            {
                'nameRU': '\u0410\u0440\u043c\u0435\u043d\u0438\u044f',
                'nameEN': 'Armenia',
                'code': '+374'
            },
            {
                'nameRU': '\u0410\u0440\u0443\u0431\u0430',
                'nameEN': 'Aruba',
                'code': '+297'
            },
            {
                'nameRU': '\u0410\u0441\u0435\u043d\u044c\u043e\u043d',
                'nameEN': 'Ascension',
                'code': '+247'
            },
            {
                'nameRU': '\u0410\u0432\u0441\u0442\u0440\u0430\u043b\u0438\u044f',
                'nameEN': 'Australia',
                'code': '+61'
            },
            {
                'nameRU': '\u0410\u0432\u0441\u0442\u0440\u0430\u043b\u0438\u0439\u0441\u043a\u0438\u0435 \u0432\u043d\u0435\u0448\u043d\u0438\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u0438',
                'nameEN': 'Australian External Territories',
                'code': '+672'
            },
            {
                'nameRU': '\u0410\u0432\u0441\u0442\u0440\u0438\u044f',
                'nameEN': 'Austria',
                'code': '+43'
            },
            {
                'nameRU': '\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043d',
                'nameEN': 'Azerbaijan',
                'code': '+994'
            },
            {
                'nameRU': '\u0410\u0437\u043e\u0440\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Azores',
                'code': '+351'
            },
            {
                'nameRU': '\u0411\u0430\u0433\u0430\u043c\u044b',
                'nameEN': 'Bahamas',
                'code': '+1-242'
            },
            {
                'nameRU': '\u0411\u0430\u0445\u0440\u0435\u0439\u043d',
                'nameEN': 'Bahrain',
                'code': '+973'
            },
            {
                'nameRU': '\u0411\u0430\u043d\u0433\u043b\u0430\u0434\u0435\u0448',
                'nameEN': 'Bangladesh',
                'code': '+880'
            },
            {
                'nameRU': '\u0411\u0430\u0440\u0431\u0430\u0434\u043e\u0441',
                'nameEN': 'Barbados',
                'code': '+1-246'
            },
            {
                'nameRU': '\u0411\u0435\u043b\u043e\u0440\u0443\u0441\u0441\u0438\u044f',
                'nameEN': 'Belarus',
                'code': '+375'
            },
            {
                'nameRU': '\u0411\u0435\u043b\u044c\u0433\u0438\u044f',
                'nameEN': 'Belgium',
                'code': '+32'
            },
            {
                'nameRU': '\u0411\u0435\u043b\u0438\u0437',
                'nameEN': 'Belize',
                'code': '+501'
            },
            {
                'nameRU': '\u0411\u0435\u043d\u0438\u043d',
                'nameEN': 'Benin',
                'code': '+229'
            },
            {
                'nameRU': '\u0411\u0435\u0440\u043c\u0443\u0434\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Bermuda',
                'code': '+1-441'
            },
            {
                'nameRU': '\u0411\u0443\u0442\u0430\u043d',
                'nameEN': 'Bhutan',
                'code': '+975'
            },
            {
                'nameRU': '\u0411\u043e\u043b\u0438\u0432\u0438\u044f',
                'nameEN': 'Bolivia',
                'code': '+591'
            },
            {
                'nameRU': '\u0411\u043e\u0441\u043d\u0438\u044f \u0438 \u0413\u0435\u0440\u0446\u0435\u0433\u043e\u0432\u0438\u043d\u0430',
                'nameEN': 'Bosnia and Herzegovina',
                'code': '+387'
            },
            {
                'nameRU': '\u0411\u043e\u0442\u0441\u0432\u0430\u043d\u0430',
                'nameEN': 'Botswana',
                'code': '+267'
            },
            {
                'nameRU': '\u0411\u0440\u0430\u0437\u0438\u043b\u0438\u044f',
                'nameEN': 'Brazil',
                'code': '+55'
            },
            {
                'nameRU': '\u0411\u0440\u0438\u0442\u0430\u043d\u0441\u043a\u0438\u0435 \u0412\u0438\u0440\u0434\u0436\u0438\u043d\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'British Virgin Islands',
                'code': '+1-284'
            },
            {
                'nameRU': '\u0411\u0440\u0443\u043d\u0435\u0439',
                'nameEN': 'Brunei',
                'code': '+673'
            },
            {
                'nameRU': '\u0411\u043e\u043b\u0433\u0430\u0440\u0438\u044f',
                'nameEN': 'Bulgaria',
                'code': '+359'
            },
            {
                'nameRU': '\u0411\u0443\u0440\u043a\u0438\u043d\u0430 \u0424\u0430\u0441\u043e',
                'nameEN': 'Burkina Faso',
                'code': '+226'
            },
            {
                'nameRU': '\u0411\u0443\u0440\u0443\u043d\u0434\u0438',
                'nameEN': 'Burundi',
                'code': '+257'
            },
            {
                'nameRU': '\u041a\u0430\u043c\u0431\u043e\u0434\u0436\u0430',
                'nameEN': 'Cambodia',
                'code': '+855'
            },
            {
                'nameRU': '\u041a\u0430\u043c\u0435\u0440\u0443\u043d',
                'nameEN': 'Cameroon',
                'code': '+237'
            },
            {
                'nameRU': '\u041a\u0430\u043f\u0435 \u0412\u0435\u0440\u0434\u0435',
                'nameEN': 'Cape Verde',
                'code': '+238'
            },
            {
                'nameRU': '\u041a\u0430\u0439\u043c\u0430\u043d\u043e\u0432\u044b \u043e-\u0432\u0430',
                'nameEN': 'Cayman Islands',
                'code': '+1-345'
            },
            {
                'nameRU': '\u0426\u0410\u0420',
                'nameEN': 'Central African Republic',
                'code': '+236'
            },
            {
                'nameRU': '\u0427\u0430\u0434',
                'nameEN': 'Chad',
                'code': '+235'
            },
            {
                'nameRU': '\u0427\u0438\u043b\u0438',
                'nameEN': 'Chile',
                'code': '+56'
            },
            {
                'nameRU': '\u041a\u0438\u0442\u0430\u0439',
                'nameEN': 'China',
                'code': '+86'
            },
            {
                'nameRU': '\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u0441\u0442\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Christmas Island',
                'code': '+672'
            },
            {
                'nameRU': '\u041a\u043e\u043a\u043e\u0441\u043e\u0432\u044b\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Cocos Islands',
                'code': '+672'
            },
            {
                'nameRU': '\u041a\u043e\u043b\u0443\u043c\u0431\u0438\u044f',
                'nameEN': 'Colombia',
                'code': '+57'
            },
            {
                'nameRU': '\u0421\u043e\u0434\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u043e \u0441\u0435\u0432\u0435\u0440\u043d\u044b\u0445 \u041c\u0430\u0440\u0438\u0430\u043d\u0441\u043a\u0438',
                'nameEN': 'Commonwealth of the Northern M',
                'code': '+1-670'
            },
            {
                'nameRU': '\u041a\u043e\u043c\u043e\u0440\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Comoros and Mayotte Island',
                'code': '+269'
            },
            {
                'nameRU': '\u041a\u043e\u043d\u0433\u043e',
                'nameEN': 'Congo',
                'code': '+242'
            },
            {
                'nameRU': '\u0414\u0435\u043c. \u0440\u0435\u0441\u043f. \u041a\u043e\u043d\u0433\u043e (\u0431\u044b\u0432\u0448. \u0417\u0430\u0438\u0440)',
                'nameEN': 'Democratic Republic (ex. Zaire)',
                'code': '+243'
            },
            {
                'nameRU': '\u041e-\u0432\u0430 \u041a\u0443\u043a\u0430',
                'nameEN': 'Cook Islands',
                'code': '+682'
            },
            {
                'nameRU': '\u041a\u043e\u0441\u0442\u0430 \u0420\u0438\u043a\u0430',
                'nameEN': 'Costa Rica',
                'code': '+506'
            },
            {
                'nameRU': '\u0425\u043e\u0440\u0432\u0430\u0442\u0438\u044f',
                'nameEN': 'Croatia',
                'code': '+385'
            },
            {
                'nameRU': '\u041a\u0443\u0431\u0430',
                'nameEN': 'Cuba',
                'code': '+53'
            },
            {
                'nameRU': '\u041a\u0438\u043f\u0440',
                'nameEN': 'Cyprus',
                'code': '+357'
            },
            {
                'nameRU': '\u0427\u0435\u0445\u0438\u044f',
                'nameEN': 'Czech Republic',
                'code': '+420'
            },
            {
                'nameRU': '\u0414\u0430\u043d\u0438\u044f',
                'nameEN': 'Denmark',
                'code': '+45'
            },
            {
                'nameRU': '\u0414\u0438\u0435\u0433\u043e \u0413\u0430\u0440\u0441\u0438\u0430',
                'nameEN': 'Diego Garcia',
                'code': '+246'
            },
            {
                'nameRU': '\u0414\u0436\u0438\u0431\u0443\u0442\u0438',
                'nameEN': 'Djibouti',
                'code': '+253'
            },
            {
                'nameRU': '\u0414\u043e\u043c\u0438\u043d\u0438\u043a\u0430',
                'nameEN': 'Dominica',
                'code': '+1-767'
            },
            {
                'nameRU': '\u0414\u043e\u043c\u0438\u043d\u0438\u043a\u0430\u043d\u0441\u043a\u0430\u044f \u0440\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430',
                'nameEN': 'Dominican Republic',
                'code': '+1-809'
            },
            {
                'nameRU': '\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439 \u0422\u0438\u043c\u043e\u0440',
                'nameEN': 'East Timor',
                'code': '+62'
            },
            {
                'nameRU': '\u042d\u043a\u0432\u0430\u0434\u043e\u0440',
                'nameEN': 'Ecuador',
                'code': '+593'
            },
            {
                'nameRU': '\u0415\u0433\u0438\u043f\u0435\u0442',
                'nameEN': 'Egypt',
                'code': '+20'
            },
            {
                'nameRU': '\u0421\u0430\u043b\u044c\u0432\u0430\u0434\u043e\u0440',
                'nameEN': 'El Salvador',
                'code': '+503'
            },
            {
                'nameRU': '\u042d\u043a\u0432\u0430\u0442\u043e\u0440\u0438\u0430\u043b\u044c\u043d\u0430\u044f \u0413\u0432\u0438\u043d\u0435\u044f',
                'nameEN': 'Equatorial Guinea',
                'code': '+240'
            },
            {
                'nameRU': '\u042d\u0440\u0438\u0442\u0440\u0438\u044f',
                'nameEN': 'Eritrea',
                'code': '+291'
            },
            {
                'nameRU': '\u042d\u0441\u0442\u043e\u043d\u0438\u044f',
                'nameEN': 'Estonia',
                'code': '+372'
            },
            {
                'nameRU': '\u042d\u0444\u0438\u043e\u043f\u0438\u044f',
                'nameEN': 'Ethiopia',
                'code': '+251'
            },
            {
                'nameRU': '\u0424\u0430\u0440\u0435\u0440\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Faeroe Islands',
                'code': '+298'
            },
            {
                'nameRU': '\u0424\u043e\u043b\u043a\u043b\u0435\u043d\u0434\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Falkland Islands',
                'code': '+500'
            },
            {
                'nameRU': '\u0424\u0438\u0434\u0436\u0438',
                'nameEN': 'Fiji',
                'code': '+679'
            },
            {
                'nameRU': '\u0424\u0438\u043d\u043b\u044f\u043d\u0434\u0438\u044f',
                'nameEN': 'Finland',
                'code': '+358'
            },
            {
                'nameRU': '\u0424\u0440\u0430\u043d\u0446\u0438\u044f',
                'nameEN': 'France',
                'code': '+33'
            },
            {
                'nameRU': '\u0424\u0440\u0430\u043d\u0446\u0443\u0437\u0441\u043a\u0438\u0435 \u0410\u043d\u0442\u0438\u043b\u043b\u044b',
                'nameEN': 'French Antilles',
                'code': '+590'
            },
            {
                'nameRU': '\u0424\u0440\u0430\u043d\u0446\u0443\u0437\u0441\u043a\u0430\u044f \u0413\u0432\u0438\u0430\u043d\u0430',
                'nameEN': 'French Guiana',
                'code': '+594'
            },
            {
                'nameRU': '\u0424\u0440\u0430\u043d\u0446\u0443\u0437\u0441\u043a\u0430\u044f \u043f\u043e\u043b\u0438\u043d\u0435\u0437\u0438\u044f',
                'nameEN': 'French Polynesia',
                'code': '+689'
            },
            {
                'nameRU': '\u0413\u0430\u0431\u043e\u043d',
                'nameEN': 'Gabonese Republic',
                'code': '+241'
            },
            {
                'nameRU': '\u0413\u0430\u043c\u0431\u0438\u044f',
                'nameEN': 'Gambia',
                'code': '+220'
            },
            {
                'nameRU': '\u0413\u0440\u0443\u0437\u0438\u044f',
                'nameEN': 'Georgia',
                'code': '+995'
            },
            {
                'nameRU': '\u0413\u0435\u0440\u043c\u0430\u043d\u0438\u044f',
                'nameEN': 'Germany',
                'code': '+49'
            },
            {
                'nameRU': '\u0413\u0430\u043d\u0430',
                'nameEN': 'Ghana',
                'code': '+233'
            },
            {
                'nameRU': '\u0413\u0438\u0431\u0440\u0430\u043b\u0442\u0430\u0440',
                'nameEN': 'Gibraltar',
                'code': '+350'
            },
            {
                'nameRU': '\u0413\u0440\u0435\u0446\u0438\u044f',
                'nameEN': 'Greece',
                'code': '+30'
            },
            {
                'nameRU': '\u0413\u0440\u0435\u043d\u043b\u0430\u043d\u0434\u0438\u044f',
                'nameEN': 'Greenland',
                'code': '+299'
            },
            {
                'nameRU': '\u0413\u0440\u0435\u043d\u0430\u0434\u0430',
                'nameEN': 'Grenada',
                'code': '+1-473'
            },
            {
                'nameRU': '\u0413\u0443\u0430\u043c',
                'nameEN': 'Guam',
                'code': '+671'
            },
            {
                'nameRU': '\u0413\u0432\u0430\u0442\u0435\u043c\u0430\u043b\u0430',
                'nameEN': 'Guatemala',
                'code': '+502'
            },
            {
                'nameRU': '\u0413\u0432\u0438\u043d\u0435\u044f',
                'nameEN': 'Guinea',
                'code': '+224'
            },
            {
                'nameRU': '\u0413\u0432\u0438\u043d\u0435\u044f \u0411\u0438\u0441\u0441\u0430\u0443',
                'nameEN': 'Guinea-Bissau',
                'code': '+245'
            },
            {
                'nameRU': '\u0413\u0430\u0439\u0430\u043d\u0430',
                'nameEN': 'Guyana',
                'code': '+592'
            },
            {
                'nameRU': '\u0413\u0430\u0438\u0442\u0438',
                'nameEN': 'Haiti',
                'code': '+509'
            },
            {
                'nameRU': '\u0413\u043e\u043d\u0434\u0443\u0440\u0430\u0441',
                'nameEN': 'Honduras',
                'code': '+504'
            },
            {
                'nameRU': '\u0413\u043e\u043d\u043a\u043e\u043d\u0433',
                'nameEN': 'Hong Kong',
                'code': '+852'
            },
            {
                'nameRU': '\u0412\u0435\u043d\u0433\u0440\u0438\u044f',
                'nameEN': 'Hungary',
                'code': '+36'
            },
            {
                'nameRU': '\u0418\u0441\u043b\u0430\u043d\u0434\u0438\u044f',
                'nameEN': 'Iceland',
                'code': '+354'
            },
            {
                'nameRU': '\u0418\u043d\u0434\u0438\u044f',
                'nameEN': 'India',
                'code': '+91'
            },
            {
                'nameRU': '\u0418\u043d\u0434\u043e\u043d\u0435\u0437\u0438\u044f',
                'nameEN': 'Indonesia',
                'code': '+62'
            },
            {
                'nameRU': '\u0418\u0440\u0430\u043d',
                'nameEN': 'Iran',
                'code': '+98'
            },
            {
                'nameRU': '\u0418\u0440\u0430\u043a',
                'nameEN': 'Iraq',
                'code': '+964'
            },
            {
                'nameRU': '\u0418\u0440\u043b\u0430\u043d\u0434\u0438\u044f',
                'nameEN': 'Irish Republic',
                'code': '+353'
            },
            {
                'nameRU': '\u0418\u0437\u0440\u0430\u0438\u043b\u044c',
                'nameEN': 'Israel',
                'code': '+972'
            },
            {
                'nameRU': '\u0418\u0442\u0430\u043b\u0438\u044f',
                'nameEN': 'Italy',
                'code': '+39'
            },
            {
                'nameRU': '\u0411\u0435\u0440\u0435\u0433 \u0441\u043b\u043e\u043d\u043e\u0432\u043e\u0439 \u043a\u043e\u0441\u0442\u0438',
                'nameEN': 'Ivory Coast',
                'code': '+225'
            },
            {
                'nameRU': '\u042f\u043c\u0430\u0439\u043a\u0430',
                'nameEN': 'Jamaica',
                'code': '+1-876'
            },
            {
                'nameRU': '\u042f\u043f\u043e\u043d\u0438\u044f',
                'nameEN': 'Japan',
                'code': '+81'
            },
            {
                'nameRU': '\u0418\u043e\u0440\u0434\u0430\u043d\u0438\u044f',
                'nameEN': 'Jordan',
                'code': '+962'
            },
            {
                'nameRU': '\u041a\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043d',
                'nameEN': 'Kazakhstan',
                'code': '+7'
            },
            {
                'nameRU': '\u041a\u0435\u043d\u0438\u044f',
                'nameEN': 'Kenya',
                'code': '+254'
            },
            {
                'nameRU': '\u041a\u0438\u0440\u0438\u0431\u0430\u0442\u0438',
                'nameEN': 'Kiribati Republic',
                'code': '+686'
            },
            {
                'nameRU': '\u0421\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u041a\u043e\u0440\u0435\u044f',
                'nameEN': 'Korea, Dem. Peoples Republic',
                'code': '+850'
            },
            {
                'nameRU': '\u042e\u0436\u043d\u0430\u044f \u041a\u043e\u0440\u0435\u044f',
                'nameEN': 'Korea Republic',
                'code': '+82'
            },
            {
                'nameRU': '\u041a\u0443\u0432\u0435\u0439\u0442',
                'nameEN': 'Kuwait',
                'code': '+965'
            },
            {
                'nameRU': '\u041a\u0438\u0440\u0433\u0438\u0437\u0441\u0442\u0430\u043d',
                'nameEN': 'Kyrgyzstan',
                'code': '+996'
            },
            {
                'nameRU': '\u041b\u0430\u043e\u0441',
                'nameEN': 'Laos',
                'code': '+856'
            },
            {
                'nameRU': '\u041b\u0430\u0442\u0432\u0438\u044f',
                'nameEN': 'Latvia',
                'code': '+371'
            },
            {
                'nameRU': '\u041b\u0438\u0432\u0430\u043d',
                'nameEN': 'Lebanon',
                'code': '+961'
            },
            {
                'nameRU': '\u041b\u0435\u0441\u0441\u043e\u0442\u043e',
                'nameEN': 'Lesotho',
                'code': '+266'
            },
            {
                'nameRU': '\u041b\u0438\u0431\u0435\u0440\u0438\u044f',
                'nameEN': 'Liberia',
                'code': '+231'
            },
            {
                'nameRU': '\u041b\u0438\u0432\u0438\u044f',
                'nameEN': 'Libya',
                'code': '+21'
            },
            {
                'nameRU': '\u041b\u0438\u0445\u0442\u0435\u043d\u0448\u0442\u0435\u0439\u043d',
                'nameEN': 'Liechtenstein',
                'code': '+41'
            },
            {
                'nameRU': '\u041b\u0438\u0442\u0432\u0430',
                'nameEN': 'Lithuania',
                'code': '+370'
            },
            {
                'nameRU': '\u041b\u044e\u043a\u0441\u0435\u043c\u0431\u0443\u0440\u0433',
                'nameEN': 'Luxembourg',
                'code': '+352'
            },
            {
                'nameRU': '\u041c\u0430\u043a\u0430\u043e',
                'nameEN': 'Macau',
                'code': '+853'
            },
            {
                'nameRU': '\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0438\u044f',
                'nameEN': 'Macedonia',
                'code': '+389'
            },
            {
                'nameRU': '\u041c\u0430\u0434\u0430\u0433\u0430\u0441\u043a\u0430\u0440',
                'nameEN': 'Madagascar',
                'code': '+261'
            },
            {
                'nameRU': '\u041c\u0430\u043b\u0430\u0432\u0438',
                'nameEN': 'Malawi',
                'code': '+265'
            },
            {
                'nameRU': '\u041c\u0430\u043b\u0430\u0439\u0437\u0438\u044f',
                'nameEN': 'Malaysia',
                'code': '+60'
            },
            {
                'nameRU': '\u041c\u0430\u043b\u044c\u0434\u0438\u0432\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Maldives',
                'code': '+960'
            },
            {
                'nameRU': '\u041c\u0430\u043b\u0438',
                'nameEN': 'Mali',
                'code': '+223'
            },
            {
                'nameRU': '\u041c\u0430\u043b\u044c\u0442\u0430',
                'nameEN': 'Malta',
                'code': '+356'
            },
            {
                'nameRU': '\u041c\u0430\u0440\u0448\u0430\u043b\u043b\u043e\u0432\u044b \u043e-\u0432\u0430',
                'nameEN': 'Marshall Islands',
                'code': '+692'
            },
            {
                'nameRU': '\u041c\u0430\u0440\u0442\u0438\u043d\u0438\u043a\u0430',
                'nameEN': 'Martinique',
                'code': '+596'
            },
            {
                'nameRU': '\u041c\u0430\u0432\u0440\u0438\u0442\u0430\u043d\u0438\u044f',
                'nameEN': 'Mauritania',
                'code': '+222'
            },
            {
                'nameRU': '\u041c\u0430\u0432\u0440\u0438\u043a\u0438\u0439',
                'nameEN': 'Mauritius',
                'code': '+230'
            },
            {
                'nameRU': '\u041c\u0435\u043a\u0441\u0438\u043a\u0430',
                'nameEN': 'Mexico',
                'code': '+52'
            },
            {
                'nameRU': '\u041c\u0438\u043a\u0440\u043e\u043d\u0435\u0437\u0438\u044f',
                'nameEN': 'Micronesia',
                'code': '+691'
            },
            {
                'nameRU': '\u041c\u043e\u043d\u0430\u043a\u043e',
                'nameEN': 'Monaco',
                'code': '+377'
            },
            {
                'nameRU': '\u041c\u043e\u043d\u0433\u043e\u043b\u0438\u044f',
                'nameEN': 'Mongolia',
                'code': '+976'
            },
            {
                'nameRU': '\u041c\u043e\u043d\u0441\u0435\u0440\u0440\u0430\u0442',
                'nameEN': 'Montserrat',
                'code': '+1-664'
            },
            {
                'nameRU': '\u041c\u043e\u043b\u0434\u0430\u0432\u0438\u044f',
                'nameEN': 'Moldova',
                'code': '+373'
            },
            {
                'nameRU': '\u041c\u0430\u0440\u043e\u043a\u043a\u043e',
                'nameEN': 'Morocco',
                'code': '+212'
            },
            {
                'nameRU': '\u041c\u043e\u0437\u0430\u043c\u0431\u0438\u043a',
                'nameEN': 'Mozambique',
                'code': '+258'
            },
            {
                'nameRU': '\u041c\u044c\u044f\u043d\u043c\u0430',
                'nameEN': 'Myanmar',
                'code': '+95'
            },
            {
                'nameRU': '\u041d\u0430\u043c\u0438\u0431\u0438\u044f',
                'nameEN': 'Namibia',
                'code': '+264'
            },
            {
                'nameRU': '\u041d\u0430\u0443\u0440\u0443',
                'nameEN': 'Nauru',
                'code': '+674'
            },
            {
                'nameRU': '\u041d\u0435\u043f\u0430\u043b',
                'nameEN': 'Nepal',
                'code': '+977'
            },
            {
                'nameRU': '\u041d\u0438\u0434\u0435\u0440\u043b\u0430\u043d\u0434\u044b',
                'nameEN': 'Netherlands',
                'code': '+31'
            },
            {
                'nameRU': '\u041d\u0438\u0434\u0435\u0440\u043b\u0430\u043d\u0434\u0441\u043a\u0438\u0435 \u0410\u043d\u0442\u0438\u043b\u043b\u044b',
                'nameEN': 'Netherlands Antilles',
                'code': '+599'
            },
            {
                'nameRU': '\u041d\u043e\u0432\u0430\u044f \u041a\u0430\u043b\u0435\u0434\u043e\u043d\u0438\u044f',
                'nameEN': 'New Caledonia',
                'code': '+687'
            },
            {
                'nameRU': '\u041d\u043e\u0432\u0430\u044f \u0417\u0435\u043b\u0430\u043d\u0434\u0438\u044f',
                'nameEN': 'New Zealand',
                'code': '+64'
            },
            {
                'nameRU': '\u041d\u0438\u043a\u0430\u0440\u0430\u0433\u0443\u0430',
                'nameEN': 'Nicaragua',
                'code': '+505'
            },
            {
                'nameRU': '\u041d\u0438\u0433\u0435\u0440',
                'nameEN': 'Niger',
                'code': '+227'
            },
            {
                'nameRU': '\u041d\u0438\u0433\u0435\u0440\u0438\u044f',
                'nameEN': 'Nigeria',
                'code': '+234'
            },
            {
                'nameRU': '\u041d\u0418\u0423\u042d',
                'nameEN': 'Niue Islands',
                'code': '+683'
            },
            {
                'nameRU': '\u041d\u043e\u0440\u0444\u043e\u043b\u043a\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Norfolk Island',
                'code': '+672'
            },
            {
                'nameRU': '\u0421\u0435\u0432\u0435\u0440\u043e-\u041c\u0430\u0440\u0438\u0430\u043d\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Northern Mariana Islands',
                'code': '+670'
            },
            {
                'nameRU': '\u041d\u043e\u0440\u0432\u0435\u0433\u0438\u044f',
                'nameEN': 'Norway',
                'code': '+47'
            },
            {
                'nameRU': '\u041e\u043c\u0430\u043d',
                'nameEN': 'Oman',
                'code': '+968'
            },
            {
                'nameRU': '\u041f\u0430\u043a\u0438\u0441\u0442\u0430\u043d',
                'nameEN': 'Pakistan',
                'code': '+92'
            },
            {
                'nameRU': '\u041f\u0430\u043b\u0430\u0443',
                'nameEN': 'Palau',
                'code': '+680'
            },
            {
                'nameRU': '\u041f\u0430\u043d\u0430\u043c\u0430',
                'nameEN': 'Panama',
                'code': '+507'
            },
            {
                'nameRU': '\u041f\u0430\u043f\u0443\u0430 \u041d\u043e\u0432\u0430\u044f \u0413\u0432\u0438\u043d\u0435\u044f',
                'nameEN': 'Papua New Guinea',
                'code': '+675'
            },
            {
                'nameRU': '\u041f\u0430\u0440\u0430\u0433\u0432\u0430\u0439',
                'nameEN': 'Paraguay',
                'code': '+595'
            },
            {
                'nameRU': '\u041f\u0435\u0440\u0443',
                'nameEN': 'Peru',
                'code': '+51'
            },
            {
                'nameRU': '\u0424\u0438\u043b\u0438\u043f\u0438\u043d\u044b',
                'nameEN': 'Philippines',
                'code': '+63'
            },
            {
                'nameRU': '\u041f\u043e\u043b\u044c\u0448\u0430',
                'nameEN': 'Poland',
                'code': '+48'
            },
            {
                'nameRU': '\u041f\u043e\u0440\u0442\u0443\u0433\u0430\u043b\u0438\u044f',
                'nameEN': 'Portugal',
                'code': '+351'
            },
            {
                'nameRU': '\u041f\u0443\u044d\u0440\u0442\u043e \u0420\u0438\u043a\u043e',
                'nameEN': 'Puerto Rico',
                'code': '+1-787'
            },
            {
                'nameRU': '\u041a\u0430\u0442\u0430\u0440',
                'nameEN': 'Qatar',
                'code': '+974'
            },
            {
                'nameRU': '\u0421\u0430\u043d \u041c\u0430\u0440\u0438\u043d\u043e',
                'nameEN': 'Republic of San Marino',
                'code': '+378'
            },
            {
                'nameRU': '\u0420\u0435\u044e\u043d\u0438\u043e\u043d',
                'nameEN': 'Reunion Islands',
                'code': '+262'
            },
            {
                'nameRU': '\u0420\u0443\u043c\u044b\u043d\u0438\u044f',
                'nameEN': 'Romania',
                'code': '+40'
            },
            {
                'nameRU': '\u0420\u043e\u0441\u0441\u0438\u044f',
                'nameEN': 'Russia',
                'code': '+7'
            },
            {
                'nameRU': '\u0420\u0443\u0430\u043d\u0434\u0430',
                'nameEN': 'Rwandese Republic',
                'code': '+250'
            },
            {
                'nameRU': '\u041e-\u0432\u0430 \u0421\u0432\u044f\u0442\u043e\u0439 \u0415\u043b\u0435\u043d\u044b',
                'nameEN': 'Saint Helena and Ascension Isl',
                'code': '+247'
            },
            {
                'nameRU': '\u0421\u0435\u043d\u0442 \u041f\u044c\u0435\u0440',
                'nameEN': 'Saint Pierre et Miquelon',
                'code': '+508'
            },
            {
                'nameRU': '\u0421\u0430\u043d \u041c\u0430\u0440\u0438\u043d\u043e',
                'nameEN': 'San Marino',
                'code': '+39'
            },
            {
                'nameRU': '\u0421\u0435\u043d\u0442 \u0422\u043e\u043c \u0438 \u041f\u0440\u0438\u043d\u0446\u0438\u043f',
                'nameEN': 'Sao Tome e Principe',
                'code': '+239'
            },
            {
                'nameRU': '\u0421\u0430\u0443\u0434\u043e\u0432\u0441\u043a\u0430\u044f \u0410\u0440\u0430\u0432\u0438\u044f',
                'nameEN': 'Saudi Arabia',
                'code': '+966'
            },
            {
                'nameRU': '\u0421\u0435\u043d\u0435\u0433\u0430\u043b',
                'nameEN': 'Senegal',
                'code': '+221'
            },
            {
                'nameRU': '\u0421\u0435\u0439\u0448\u0435\u043b\u044c\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'Seychelles',
                'code': '+248'
            },
            {
                'nameRU': '\u0421\u044c\u0435\u0440\u0440\u0430 \u041b\u0435\u043e\u043d\u0435',
                'nameEN': 'Sierra Leone',
                'code': '+232'
            },
            {
                'nameRU': '\u0421\u0438\u043d\u0433\u0430\u043f\u0443\u0440',
                'nameEN': 'Singapore',
                'code': '+65'
            },
            {
                'nameRU': '\u0421\u043b\u043e\u0432\u0430\u043a\u0438\u044f',
                'nameEN': 'Slovak Republic',
                'code': '+421'
            },
            {
                'nameRU': '\u0421\u043b\u043e\u0432\u0435\u043d\u0438\u044f',
                'nameEN': 'Slovenia',
                'code': '+386'
            },
            {
                'nameRU': '\u0421\u043e\u043b\u043e\u043c\u043e\u043d\u043e\u0432\u044b \u043e-\u0432\u0430',
                'nameEN': 'Solomon Islands',
                'code': '+677'
            },
            {
                'nameRU': '\u0421\u043e\u043c\u0430\u043b\u0438',
                'nameEN': 'Somalia',
                'code': '+252'
            },
            {
                'nameRU': '\u042e\u0410\u0420',
                'nameEN': 'South Africa',
                'code': '+27'
            },
            {
                'nameRU': '\u0418\u0441\u043f\u0430\u043d\u0438\u044f',
                'nameEN': 'Spain',
                'code': '+34'
            },
            {
                'nameRU': '\u0428\u0440\u0438 \u041b\u0430\u043d\u043a\u0430',
                'nameEN': 'Sri Lanka',
                'code': '+94'
            },
            {
                'nameRU': '\u0421\u0435\u043d\u0442-\u041a\u0438\u0442\u0441 \u0438 \u041d\u0435\u0432\u0438\u0441',
                'nameEN': 'St. Kitts and Nevis',
                'code': '+1-869'
            },
            {
                'nameRU': '\u0421\u0430\u043d\u0442\u0430 \u041b\u044e\u0447\u0438\u044f',
                'nameEN': 'St. Lucia',
                'code': '+1-758'
            },
            {
                'nameRU': '\u0421\u0435\u043d\u0442 \u0412\u0438\u043d\u0446\u0435\u043d\u0442 \u0438 \u0413\u0440\u0435\u043d\u0430\u0434\u0438\u043d\u044b',
                'nameEN': 'St. Vincent and the Grenadines',
                'code': '+1-784'
            },
            {
                'nameRU': '\u0421\u0443\u0434\u0430\u043d',
                'nameEN': 'Sudan',
                'code': '+249'
            },
            {
                'nameRU': '\u0421\u0443\u0440\u0438\u043d\u0430\u043c',
                'nameEN': 'Suriname',
                'code': '+597'
            },
            {
                'nameRU': '\u0421\u0432\u0430\u043b\u0431\u0430\u0440\u0434',
                'nameEN': 'Svalbard and Jan Mayen Islands',
                'code': '+47'
            },
            {
                'nameRU': '\u0421\u0432\u0430\u0437\u0438\u043b\u0435\u043d\u0434',
                'nameEN': 'Swaziland',
                'code': '+268'
            },
            {
                'nameRU': '\u0428\u0432\u0435\u0446\u0438\u044f',
                'nameEN': 'Sweden',
                'code': '+46'
            },
            {
                'nameRU': '\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0438\u044f',
                'nameEN': 'Switzerland',
                'code': '+41'
            },
            {
                'nameRU': '\u0421\u0438\u0440\u0438\u044f',
                'nameEN': 'Syria',
                'code': '+963'
            },
            {
                'nameRU': '\u0422\u0430\u0439\u0432\u0430\u043d\u044c',
                'nameEN': 'Taiwan',
                'code': '+886'
            },
            {
                'nameRU': '\u0422\u0430\u0434\u0436\u0438\u043a\u0438\u0441\u0442\u0430\u043d',
                'nameEN': 'Tajikistan',
                'code': '+992'
            },
            {
                'nameRU': '\u0422\u0430\u043d\u0437\u0430\u043d\u0438\u044f',
                'nameEN': 'Tanzania',
                'code': '+255'
            },
            {
                'nameRU': '\u0422\u0430\u0439\u043b\u0430\u043d\u0434',
                'nameEN': 'Thailand',
                'code': '+66'
            },
            {
                'nameRU': '\u0422\u043e\u0433\u043e\u043b\u0435\u0437\u0435',
                'nameEN': 'Togolese Republic',
                'code': '+228'
            },
            {
                'nameRU': '\u0422\u043e\u043a\u0435\u043b\u0430\u0443',
                'nameEN': 'Tokelau',
                'code': '+690'
            },
            {
                'nameRU': '\u0422\u043e\u043d\u0433\u043e',
                'nameEN': 'Tonga',
                'code': '+676'
            },
            {
                'nameRU': '\u0422\u0440\u0438\u043d\u0438\u0434\u0430\u0434 \u0438 \u0422\u043e\u0431\u0430\u0433\u043e',
                'nameEN': 'Trinidad and Tobago',
                'code': '+1-868'
            },
            {
                'nameRU': '\u0422\u0443\u043d\u0438\u0441',
                'nameEN': 'Tunisia',
                'code': '+21'
            },
            {
                'nameRU': '\u0422\u0443\u0440\u0446\u0438\u044f',
                'nameEN': 'Turkey',
                'code': '+90'
            },
            {
                'nameRU': '\u0422\u0443\u0440\u043a\u043c\u0435\u043d\u0438\u0441\u0442\u0430\u043d',
                'nameEN': 'Turkmenistan',
                'code': '+993'
            },
            {
                'nameRU': '\u0422\u0435\u043a\u0441 \u0438 \u041a\u0430\u0438\u043a\u043e\u0441 \u0410\u0439\u043b\u0430\u043d\u0434\u0441',
                'nameEN': 'Turks & Caicos Islands',
                'code': '+1-649'
            },
            {
                'nameRU': '\u0422\u0443\u0432\u0430\u043b\u0443',
                'nameEN': 'Tuvalu',
                'code': '+688'
            },
            {
                'nameRU': '\u0423\u0433\u0430\u043d\u0434\u0430',
                'nameEN': 'Uganda',
                'code': '+256'
            },
            {
                'nameRU': '\u0423\u043a\u0440\u0430\u0438\u043d\u0430',
                'nameEN': 'Ukraine',
                'code': '+380'
            },
            {
                'nameRU': '\u041e\u0410\u042d',
                'nameEN': 'United Arab Emirates',
                'code': '+971'
            },
            {
                'nameRU': '\u0412\u0435\u043b\u0438\u043a\u043e\u0431\u0440\u0438\u0442\u0430\u043d\u0438\u044f',
                'nameEN': 'United Kingdom',
                'code': '+44'
            },
            {
                'nameRU': '\u0423\u0440\u0443\u0433\u0432\u0430\u0439',
                'nameEN': 'Uruguay',
                'code': '+598'
            },
            {
                'nameRU': '\u0412\u0438\u0440\u0434\u0436\u0438\u043d\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430',
                'nameEN': 'US Virgin Islands',
                'code': '+1-340'
            },
            {
                'nameRU': '\u0421\u0428\u0410',
                'nameEN': 'US\u0410',
                'code': '+1'
            },
            {
                'nameRU': '\u0423\u0437\u0431\u0435\u043a\u0438\u0441\u0442\u0430\u043d',
                'nameEN': 'Uzbekistan',
                'code': '+998'
            },
            {
                'nameRU': '\u0412\u0430\u043d\u0443\u0430\u0442\u0443',
                'nameEN': 'Vanuatu',
                'code': '+678'
            },
            {
                'nameRU': '\u0412\u0430\u0442\u0438\u043a\u0430\u043d',
                'nameEN': 'Vatican City State',
                'code': '+39'
            },
            {
                'nameRU': '\u0412\u0435\u043d\u0435\u0441\u0443\u044d\u043b\u0430',
                'nameEN': 'Venezuela',
                'code': '+58'
            },
            {
                'nameRU': '\u0412\u044c\u0435\u0442\u043d\u0430\u043c',
                'nameEN': 'Vietnam',
                'code': '+84'
            },
            {
                'nameRU': '\u042d\u043b\u043b\u0438\u0441 \u0438 \u0424\u0443\u0442\u0443\u043d\u0430 \u043e\u0441\u0442\u0440\u043e\u0432\u0430',
                'nameEN': 'Wallis and Futuna',
                'code': '+681'
            },
            {
                'nameRU': '\u0417\u0430\u043f\u0430\u0434\u043d\u0430\u044f \u0421\u0430\u0445\u0430\u0440\u0430',
                'nameEN': 'Western Sahara',
                'code': '+21'
            },
            {
                'nameRU': '\u0417\u0430\u043f\u0430\u0434\u043d\u043e\u0435 \u0421\u0430\u043c\u043e\u0430',
                'nameEN': 'Western Samoa',
                'code': '+685'
            },
            {
                'nameRU': '\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0419\u0435\u043c\u0435\u043d',
                'nameEN': 'Yemen, North',
                'code': '+967'
            },
            {
                'nameRU': '\u042e\u0436\u043d\u044b\u0439 \u0419\u0435\u043c\u0435\u043d',
                'nameEN': 'Yemen, South',
                'code': '+969'
            },
            {
                'nameRU': '\u042e\u0433\u043e\u0441\u043b\u0430\u0432\u0438\u044f',
                'nameEN': 'Yugoslavia',
                'code': '+381'
            },
            {
                'nameRU': '\u0417\u0430\u0438\u0440',
                'nameEN': 'Zaire',
                'code': '+243'
            },
            {
                'nameRU': '\u0417\u0430\u043c\u0431\u0438\u044f',
                'nameEN': 'Zambia',
                'code': '+260'
            },
            {
                'nameRU': '\u0417\u0430\u043d\u0437\u0438\u0431\u0430\u0440',
                'nameEN': 'Zanzibar',
                'code': '+259'
            },
            {
                'nameRU': '\u0417\u0438\u043c\u0431\u0430\u0431\u0432\u0435',
                'nameEN': 'Zimbabwe',
                'code': '+263'
            }
        ],
        selected: null,
        isOpen: false
      }
    },
    methods: {
      setSelected (item) {
        this.selected = item;
        this.$store.commit('answers/updPhonePrefix', item);
        if (this.cb) {
          this.$emit('cb');
        }
      },
      toggleState () {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
          let selected = this.$refs.telPrefixList.querySelector('.is-selected');
          if (selected) {
            selected.scrollIntoView();
            // this.$refs.telPrefixList.scrollTop(selected.offsetTop)
          }
        }
      }
    }
  }
</script>

<style lang="scss" src="./assets/dropdown.scss"></style>
